"use strict";

function linear(args) {
  var opts = args.opts,
      component = args.component,
      quantity = args.quantity,
      product = args.product;
  var from = opts.from,
      key = opts.key,
      m = opts.m,
      b = opts.b;
  var val;

  if (from === 'product') {
    val = parseInt(product[key], 10);
  } else if (key === 'quantity') {
    val = parseInt(quantity, 10);
  } else {
    val = parseInt(component[key], 10);
  }

  if (Number.isNaN(val)) {
    console.error('value was not a number');
    console.log({
      component: component,
      key: key,
      val: val
    });
    return 0;
  }

  return m * val + b;
}

module.exports = linear;